import type { AxiosRequestConfig } from 'axios';
import { apiClient } from '../client';

/**
 * Orval mutator: forwards to our axios client (baseURL, auth, 401 handling).
 * Generated code sends path like /api/v1/sports; our client has baseURL with /api/v1,
 * so we strip the leading /api/v1 to avoid duplication.
 */
export const customInstance = <T>(config: AxiosRequestConfig, options?: AxiosRequestConfig): Promise<T> => {
  const url = config.url?.replace(/^\/api\/v1/, '') ?? config.url;
  const requestConfig: AxiosRequestConfig = {
    ...config,
    ...options,
    // Preserve generated query params unless caller explicitly provides params.
    params: options?.params ?? config.params,
    // Merge headers instead of replacing them wholesale.
    headers: {
      ...(config.headers ?? {}),
      ...(options?.headers ?? {}),
    },
    url,
  };

  return apiClient.request<T>(requestConfig);
};

export type ErrorType<Error> = import('axios').AxiosError<Error>;
